import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/tariffs', request)
}

export {get}
